import { ContentMap } from '@models/app.models';

const DEFAULT_CONTENT_MAP: Record<string, ContentMap> = {
  insurance: {
    companies: ['helsana', 'sanitas', 'helvetia', 'css', 'dextra'],
    features: [
      'online-booking',
      'room-booking',
      'surveys-configurators',
      'automated-messages',
      'video-voice-meetings',
      'analytics-tracking',
    ],
    usp: ['security', 'customizing', 'support'],
    statistics: ['basel', 'helvetia', 'amag'],
    ref_stories: ['css', 'sanitas', 'groupemutuel', 'ochsner'],
  },
};

export { DEFAULT_CONTENT_MAP };
